var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c("div", { staticClass: "progress2 progress-moved" }, [
        _c("div", { staticClass: "progress-bar2" }),
      ])
    : _c("div", { staticClass: "header-border" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }